import { useState } from 'react';
import { v4 as uuid } from "uuid";
import './App.css';
import Header from './components/Header/Header';
import Formulario from './components/Formulario/Formulario';
import MiOrg from './components/MiOrg';
import Equipo from './components/Equipo';
import Footer from './components/Footer';

function App() {
  const [mostrarFormulario, actualizarMostrar] = useState(false)
  const [colaboradores, actualizarColaboradores] = useState([
  {
    id: uuid(),
    equipo: "Front End",
    foto: "https://github.com/VannDennOk.png",
    nombre: "Vanina Denegri",
    puesto: "Trainee IT",
    fav: true
  },
  {
    id: uuid(),
    equipo: "Programación",
    foto: "https://github.com/harlandlohora.png",
    nombre: "Harland Lohora",
    puesto: "Instructor en Alura Latam",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Devops",
    foto: "https://github.com/JeanmarieAluraLatam.png",
    nombre: "JeanMarie Quijada",
    puesto: "Instructora en Alura Latam",
    fav: false
  },
  {
    id: uuid(),
    equipo: "UX y Diseño",
    foto: "https://github.com/christianpva.png",
    nombre: "Christian Velasco",
    puesto: "Head de Alura e Instructor",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Móvil",
    foto: "https://github.com/JoseDarioGonzalezCha.png",
    nombre: "José Gonzalez",
    puesto: "Dev. FullStack",
    fav: false
  },
  {
    id: uuid(),
    equipo: "UX y Diseño",
    foto: "https://github.com/VannDennOk.png",
    nombre: "Vanina Denegri",
    puesto: "Trainee IT",
    fav: true
  },
  {
    id: uuid(),
    equipo: "Data Science",
    foto: "https://github.com/harlandlohora.png",
    nombre: "Harland Lohora",
    puesto: "Instructor en Alura Latam",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Front End",
    foto: "https://github.com/JeanmarieAluraLatam.png",
    nombre: "JeanMarie Quijada",
    puesto: "Instructora en Alura Latam",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Programación",
    foto: "https://github.com/christianpva.png",
    nombre: "Christian Velasco",
    puesto: "Head de Alura e Instructor",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Data Science",
    foto: "https://github.com/JoseDarioGonzalezCha.png",
    nombre: "José Gonzalez",
    puesto: "Dev. FullStack",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Devops",
    foto: "https://github.com/JoseDarioGonzalezCha.png",
    nombre: "José Gonzalez",
    puesto: "Dev. FullStack",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Móvil",
    foto: "https://github.com/JeanmarieAluraLatam.png",
    nombre: "JeanMarie Quijada",
    puesto: "Instructora en Alura Latam",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Innovación y Gestión",
    foto: "https://github.com/christianpva.png",
    nombre: "Christian Velasco",
    puesto: "Head de Alura e Instructor",
    fav: false
  },
  {
    id: uuid(),
    equipo: "Innovación y Gestión",
    foto: "https://github.com/harlandlohora.png",
    nombre: "Harland Lohora",
    puesto: "Instructor en Alura Latam",
    fav: false
  },
])

const [equipos, actualizarEquipos] = useState([
  {
    id: uuid(),
    titulo: "Programación",
    colorPrimario: "#57c278",
    colorSecundario: "#de9f7e9"
  },
  {
    id: uuid(),
    titulo: "Front End",
    colorPrimario: "#82cffa",
    colorSecundario: "#e8f8ff"
  },
  {
    id: uuid(),
    titulo: "Data Science",
    colorPrimario: "#a6d157",
    colorSecundario: "#f0f8e2"
  },
  {
    id: uuid(),
    titulo: "Devops",
    colorPrimario: "#e06b69",
    colorSecundario: "#fde7e8"
  },
  {
    id: uuid(),
    titulo: "UX y Diseño",
    colorPrimario: "#db6ebf",
    colorSecundario: "#fae9f5"
  },
  {
    id: uuid(),
    titulo: "Móvil",
    colorPrimario: "#ffba05",
    colorSecundario: "#fff5d9"
  },
  {
    id: uuid(),
    titulo: "Innovación y Gestión",
    colorPrimario: "#ff8a29",
    colorSecundario: "#ffeedf"
  }
])

  //CAMBIA OCULTAR/MOSTRAR EL FORMULARIO
  const cambiarMostrar = () => {
    actualizarMostrar(!mostrarFormulario)
  }

  //REGISTRA COLABORADORES
  const registrarColaborador = (colaborador) => {
    console.log("Nuevo colaborador", colaborador)
    //Spread operator
    actualizarColaboradores([...colaboradores, colaborador])
  }

  //ELIMINAR COLABORADORES
  const eliminarColaborador = (id) => {
    const nuevosColaboradores = colaboradores.filter((colaborador) => colaborador.id !== id) 
    actualizarColaboradores(nuevosColaboradores)
  }

  //ACTUALIZAR COLOR DE EQUIPO
  const actualizarColor = (color, id) =>{
    console.log("Actualizar: ", color, id)
    const equiposActualizados = equipos.map((equipo) => {
      if(equipo.id === id){
        equipo.colorPrimario = color
      }
      return equipo
    })

    actualizarEquipos(equiposActualizados)    
  }

  //CREAR NUEVO EQUIPO
  const crearEquipo = (nuevoEquipo) => {
    console.log(nuevoEquipo)
    actualizarEquipos([...equipos, { ...nuevoEquipo, id: uuid()}])
  }

  //LIKE COLABORADOR
  const like = (id) => {
    const colaboradoresActualizados = colaboradores.map((colaborador) => {
      if(colaborador.id === id){
        colaborador.fav = !colaborador.fav 
      }
      return colaborador

    })

    actualizarColaboradores(colaboradoresActualizados)

  }

  //NOS DEVUELVE LA ESTRUCTURA HTML
  return (
    <div>
      
      {/* HEADER */}
      <Header />

      {/* FORMULARIO QUE SE OCULTA/MUESTRA */}
      {
        mostrarFormulario && <Formulario 
          equipos={equipos.map((equipo) => equipo.titulo)}
          registrarColaborador={registrarColaborador}
          crearEquipo={crearEquipo}
        />
      }

      {/* ENCABEZADO --> ACÁ SE APLICA EL OCULTAR/MOSTRAR EL FORMULARIO */}
      <MiOrg cambiarMostrar={cambiarMostrar} />

      {/* SECCIÓN CON LOS DISTINTOS EQUIPOS */}
      {
        equipos.map( (equipo) => <Equipo 
        datos={equipo} 
        key={equipo.titulo} 
        colaboradores={colaboradores.filter( colaborador => colaborador.equipo === equipo.titulo)}
        eliminarColaborador={eliminarColaborador} 
        actualizarColor={actualizarColor}
        like={like} 
        />
        )
      }

      {/* FOOTER */}
      <Footer />



    </div>
  );
}

export default App;

//Ternario y distintas formas de escribirlo:
  //{mostrarFormulario === true ? <Formulario /> : <div></div>}
  //{mostrarFormulario ? <Formulario /> : <div></div>} 
  //{mostrarFormulario ? <Formulario /> : <></>}
  //{mostrarFormulario && <Formulario />}